import ko from 'knockout';
import numeral from 'numeral';

export const formatMargin = (hours: number, margin: number) => {
    const formattedMargin = numeral(margin).format('$0,0.00');
    return `${formattedMargin} (${Math.round(hours)}u)`;
};

export const formatMarginNoHours = (margin: number) => {
    return numeral(margin).format('$0,0.00');
};

export class RequestOverviewMarginModel {
    id: KnockoutObservable<string>;

    totalHours: KnockoutObservable<number>;
    targetHours: KnockoutObservable<number>;
    pendingHours: KnockoutObservable<number>;
    plannedHours: KnockoutObservable<number>;
    remainingHours: KnockoutObservable<number>;

    targetMargin: KnockoutObservable<number>;
    targetMarginMax: KnockoutObservable<number>;
    pendingMargin: KnockoutObservable<number>;
    pendingMarginMax: KnockoutObservable<number>;
    plannedMargin: KnockoutObservable<number>;
    remainingMargin: KnockoutObservable<number>;
    remainingMarginMax: KnockoutObservable<number>;

    constructor(model: any = {}) {
        this.id = ko.observable<string>(model.id);

        const stats = model.marginStatistics;
        this.totalHours = ko.observable<number>(stats?.totalHours ?? 0);
        this.targetHours = ko.observable<number>(stats?.targetHours ?? 0);
        this.pendingHours = ko.observable<number>(stats?.pendingHours ?? 0);
        this.plannedHours = ko.observable<number>(stats?.plannedHours ?? 0);
        this.remainingHours = ko.observable<number>(stats?.remainingHours ?? 0);

        this.targetMargin = ko.observable<number>(stats?.targetMargin ?? 0);
        this.targetMarginMax = ko.observable<number>(
            stats?.targetMarginMax ?? 0,
        );
        this.pendingMargin = ko.observable<number>(stats?.pendingMargin ?? 0);
        this.pendingMarginMax = ko.observable<number>(
            stats?.pendingMarginMax ?? 0,
        );
        this.plannedMargin = ko.observable<number>(stats?.plannedMargin ?? 0);
        this.remainingMargin = ko.observable<number>(
            stats?.remainingMargin ?? 0,
        );
        this.remainingMarginMax = ko.observable<number>(
            stats?.remainingMarginMax ?? 0,
        );
    }
}
